<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createPartnerData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable">
            <td width="5%" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.branch ? data.branch.branch_name_en : ''}}</td>
            <td width="10%" align="center">
              <v-icon v-if="data.is_main_partner" color="#2E8037">fas fa-check</v-icon>
            </td>
            <td>{{data.name_th}}</td>
            <td>{{data.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showPartnerData(data.partner_id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import InputSearch from "../../../components/Input/InputSearch";
    import CircleButton from "../../../components/Button/CircleButton";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import Paginate from "../../../components/Layout/Paginate";
    export default {
        name: "PartnerTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch},
      data(){
        return{
          title: "Partner",
          headers: [
            { id: 1, text: "No." },
            { id: 2, text: "Branch" },
            { id: 3, text: "Main" },
            { id: 4, text: "Partner" },
            { id: 5, text: "Update date" },
            { id: 6, text: "Edit" }
          ],
          dataTable: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          }
        }
      },
      created() {
          this.getPartnerTable(1);
      },
      methods:{
        getPartnerTable(page){
          this.$store.dispatch("Partner/getPartner",page).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
          }).catch(()=>{
            alert('cannot get Partner data');
          });
        },
        changePage(val){
          this.dataPaginate.current_page = val;
          this.$store.dispatch("Partner/getPartner", this.dataPaginate.current_page).then(res => {
            if (res.response_code == 200) {
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            } else {
              alert(res.response_msg);
            }
          });
        },
        goToPartnerEdit(){
          this.$router.push("/partner/edit");
        },
        showPartnerData(id){
          this.$store.dispatch("Partner/showPartner",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("Partner/setFormPartner",res.result).then(()=>{
                this.goToPartnerEdit();
              })
            }
          }).catch(()=>{
            alert('cannot get Partner data');
          })
        },
        createPartnerData(){
          this.$store.dispatch("Partner/clearFormData").then(()=>{
            this.goToPartnerEdit();
          })
        },
      }
    }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
